import type { StandardProposalPageView } from "@buildpy/core/views/g5a/standard-proposals";

import ProposalDetail from "@/modules/process-standard/ui/proposal-detail";
import StandardsShell from "@/modules/process-standard/ui/standards-shell";

// 숫자 제안 하나 — 찬반 사유·찬반 남기기.
const Page = ({ data }: { data: StandardProposalPageView }) => (
  <StandardsShell tab="proposals">
    <ProposalDetail data={data} />
  </StandardsShell>
);

export default Page;
